import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SupportloginComponent } from './login/supportlogin/supportlogin.component';

const routes: Routes = [
  { path: '', redirectTo: 'es', pathMatch: 'full' },
  { path: 'en', component: SupportloginComponent, data : {idioma : 'en'} },
  { path: 'es', component: SupportloginComponent, data : {idioma : 'es'} },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
